import React, {useState, useRef, useEffect} from 'react'
import {observer} from 'mobx-react-lite'
import readXlsxFile from 'read-excel-file'
import writeXlsxFile from 'write-excel-file'
import {
  Row,
  Col,
  FormCheck,
  Button,
  FormSelect,
  FormControl,
  DropdownButton,
  Dropdown,
} from 'react-bootstrap'
import {FaCheckCircle, FaOrcid, FaTimesCircle} from 'react-icons/fa'
import {Typeahead, ClearButton} from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'

import StoryContext from '../store/context'
import Map from '../components/Map'
import {schemaRoutes} from '../utils/excel'

const dayweek = [
  {uuid: 'all', name: 'Всі'},
  {uuid: 'monday', name: 'Понеділок'},
  {uuid: 'tuesday', name: 'Вівторок'},
  {uuid: 'wednesday', name: 'Середа'},
  {uuid: 'thursday', name: 'Четвер'},
  {uuid: 'friday', name: 'Пятниця'},
  {uuid: 'saturday', name: 'Субота'},
  {uuid: 'sunday', name: 'Неділя'},
]

const Check = observer(({item, name}) => {
  const onClick = () => item.setDay(name, !item[name])

  return (
    <div style={{width: 25}}>
      <FormCheck checked={item[name]} onChange={onClick} />
    </div>
  )
})

const SelectWeek = () => (
  <FormSelect>
    {dayweek.map(item => (
      <option key={item.uuid} value={item.uuid}>
        {item.name}
      </option>
    ))}
  </FormSelect>
)

const Checklable = ({title}) => <div style={{width: 25}}>{title}</div>

const OutletActivity = ({active}) => {
  const label = active ? 'Торгова точка активна' : 'Торгова точка неактивна'
  const Icon = active ? FaCheckCircle : FaTimesCircle

  return (
    <Icon
      aria-label={label}
      color={active ? '#198754' : '#6c757d'}
      fontSize={20}
      title={label}
    />
  )
}

const Routes = observer(() => {
  const store = React.useContext(StoryContext)

  const [selectedM, setSelectedM] = useState('1111')
  const [center, setCenter] = useState([60, 30])

  const saveRoute = () => {
    store.saveRoute()
  }

  const select_null = {uuid: '1111', name: 'Невибрано'}

  const sortM = (a, b) => (a.name < b.name ? -1 : 1)

  const currentOutlets = store.outlets.filter(
    item => item.merchandiser && selectedM === item.merchandiser.uuid,
  )

  const save = mode => async () => {
    await writeXlsxFile(mode === 1 ? currentOutlets : store.outlets, {
      schema: schemaRoutes,
      fileName: 'outlets.xlsx', //
    })
  }

  const onSelect = item => {
    if (item[0]) {
      setSelectedM(item[0].uuid)
    } else {
      setSelectedM('111')
    }
  }

  let file = useRef(null)

  useEffect(() => {
    const lister = () => {
      readXlsxFile(file.current.files[0]).then(data => {
        if (Array.isArray(data)) {
          store.saveOutlets(
            data.map(item => ({outlet: item[1], merchandiser: item[5]})),
          )
        }
      })
    }
    file.current.addEventListener('input', lister)
    return () => {
      file.current && file.current.removeEventListener('input', lister)
    }
  }, [])

  const load = () => {
    file.current.click()
  }

  return (
    <Row>
      <Col xl={5} lg={12}>
        <Typeahead
          id="basic-example"
          onChange={onSelect}
          options={store.employees.map(item => ({...item, label: item.name}))}
          placeholder="Укажіть робітника...">
          {({onClear, selected}) => (
            <div className="rbt-aux">
              {!!selected.length && <ClearButton onClick={onClear} />}
            </div>
          )}
        </Typeahead>

        <Row
          style={{
            borderBottomWidth: 2,
            borderBottomStyle: 'inset',
            borderBottomColor: 'black',
          }}>
          <Col md={4}>Торгова точка</Col>
          <Col md={1} className="d-flex align-items-center justify-content-center">
            Активна
          </Col>
          <Col md={1}></Col>
          <Col>Клієнт</Col>
          <Col
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <Row>
              <Checklable title="Пн" />
              <Checklable title="Вт" />
              <Checklable title="Ср" />
              <Checklable title="Чт" />
              <Checklable title="Пт" />
              <Checklable title="Сб" />
              <Checklable title="Нд" />
            </Row>
          </Col>
        </Row>
        {currentOutlets.sort(sortM).map(item => (
          <Row key={item.uuid}>
            <Col
              md={4}
              style={{
                display: 'flex',
                alignItems: 'center',
              }}>
              {item.name}
            </Col>
            <Col
              md={1}
              className="d-flex align-items-center justify-content-center">
              <OutletActivity active={item.active} />
            </Col>
            <Col
              md={1}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              {
                <FaOrcid
                  color={!item.longitude || !item.latitude ? 'red' : 'blue'}
                  fontSize={25}
                  onClick={() => {
                    setCenter([item.latitude, item.longitude])
                  }}
                />
              }
            </Col>
            <Col
              style={{
                display: 'flex',
                alignItems: 'center',
              }}>
              {item.client.name}
            </Col>
            <Col
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <Row>
                <Check item={item} name="monday" />
                <Check item={item} name="tuesday" />
                <Check item={item} name="wednesday" />
                <Check item={item} name="thursday" />
                <Check item={item} name="friday" />
                <Check item={item} name="saturday" />
                <Check item={item} name="sunday" />
              </Row>
            </Col>
          </Row>
        ))}
      </Col>
      <Col>
        <Row>
          <Col style={{display: 'flex', justifyContent: 'end'}}>
            <SelectWeek />
            <FormControl
              type="file"
              style={{display: 'none'}}
              ref={file}
              accept=".xlsx"
            />
            <Button style={{margin: 2}} onClick={saveRoute}>
              Зберегти
            </Button>
            <DropdownButton
              id="dropdown-basic-button"
              title="EXCEL"
              style={{margin: 2}}>
              <Dropdown.Item onClick={save(1)}>
                Выгрузить мерчендазера
              </Dropdown.Item>
              <Dropdown.Item onClick={save(2)}>Выгрузить всех</Dropdown.Item>
              <Dropdown.Item onClick={load}>Загрузить</Dropdown.Item>
            </DropdownButton>
          </Col>
        </Row>
        <div style={{height: 700}}>
          <Map
            center={center}
            marckers={currentOutlets}
            setCenter={setCenter}
            drag
          />
        </div>
      </Col>
    </Row>
  )
})

export default Routes
